import React, { useEffect } from 'react';
import { Popover, PopoverProps } from 'react-tiny-popover';
import styled from 'styled-components';
import { IoMdClose } from 'react-icons/io';
import { isMobile } from '@/components/responsive';
import Portal from '@/components/portal';
import { BACKDROP_ZINDEX } from '@/components/shared-element-overlay';

const EMPTY_RECT = {
  height: `auto`,
  width: `auto`,
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
};

export function ResponsivePopover(props: PopoverProps) {
  const { children, ...rest } = props;
  const isMobileDevice = isMobile();

  const [shown, setShown] = React.useState(false);

  useEffect(() => {
    if (!rest.isOpen) {
      setShown(false);
    }
  }, [rest.isOpen, setShown]);

  const onBackdropClicked = (ev) => {
    if (ev.target.classList.contains(`vsly-backdrop`)) {
      close();
    }
  };

  const close = () => {
    setShown(false);
  };

  return (
    <>
      {shown && (
        <Portal selector="body">
          <Backdrop className="vsly-backdrop" onClick={onBackdropClicked}>
            <MobilePopover>
              <CloseButton onClick={close}>
                <IoMdClose size={20} />
              </CloseButton>
              {/* @ts-ignore */}
              {rest.content({
                position: `top`,
                childRect: EMPTY_RECT,
                popoverRect: EMPTY_RECT,
              })}
            </MobilePopover>
          </Backdrop>
        </Portal>
      )}
      {isMobileDevice ? (
        <div onClick={() => setShown(true)}>{children}</div>
      ) : (
        <Popover {...rest} onClickOutside={rest?.onClickOutside}>
          {children}
        </Popover>
      )}
    </>
  );
}

const MobilePopover = styled.div`
  position: fixed;
  top: unset;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100vw;
  height: auto;

  && > :nth-child(2) {
    padding: 0 !important;
  }
  .popover-arrow-container {
    padding: 0 !important;
    margin: 0 !important;
  }
`;

const Backdrop = styled.div`
  position: fixed;
  cursor: pointer;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  height: 100%;
  width: 100vw;
  background: rgba(238, 238, 238, 0.76);
  backdrop-filter: blur(4px);
  z-index: ${BACKDROP_ZINDEX};
`;

const CloseButton = styled.div`
  position: absolute;
  right: 2rem;
  top: -5rem;
  border-radius: 50%;
  color: #979797;
  background: white;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.08);
  height: 3.5rem;
  width: 3.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;
